import React, { useState } from "react";
import {
  ChangeSetDataFileModel,
  ChangeSetVehicleModel,
  getDataFileTypeLabel,
} from "../api/vehicleFileAPI";
import { Card, Col, Row, Table } from "react-bootstrap";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";

interface ChangeSetDisplayProps {
  dataFiles: ChangeSetDataFileModel[];
  vehicles: ChangeSetVehicleModel[];
  children?: React.ReactNode;
}

function ChangeSetDisplay({
  dataFiles,
  vehicles,
  children,
}: ChangeSetDisplayProps) {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <Card className="mb-2">
      <Card.Header className="dark">
        <Row>
          <Col>{children}</Col>
          <Col md="auto" className="align-self-center">
            {collapsed && (
              <ChevronDown
                role="button"
                size={24}
                onClick={() => setCollapsed(false)}
              />
            )}
            {!collapsed && (
              <ChevronUp
                role="button"
                size={24}
                onClick={() => setCollapsed(true)}
              />
            )}
          </Col>
        </Row>
      </Card.Header>
      {!collapsed && (
        <Card.Body>
          <div className="mx-2">
            {dataFiles.length > 0 && (
              <>
                <h5>Data files</h5>
                <div
                  className="fixed-table-header"
                  style={{ maxHeight: "200px" }}
                >
                  <Table size="sm" striped bordered>
                    <thead>
                      <tr>
                        <th>Filename</th>
                        <th>Type</th>
                        <th>Version</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataFiles.map((df, index) => (
                        <tr key={index}>
                          <td>{df.fileName}</td>
                          <td>{getDataFileTypeLabel(df.type)}</td>
                          <td>{df.version}</td>
                          <td>{df.deleted && "deleted"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
            {vehicles.length > 0 && (
              <>
                <h5>Vehicles</h5>
                <div
                  className="fixed-table-header"
                  style={{ maxHeight: "200px" }}
                >
                  <Table size="sm" striped bordered>
                    <thead>
                      <th>Rec ID</th>
                      <th>Version</th>
                      <th></th>
                    </thead>
                    <tbody>
                      {vehicles.map((v, index) => (
                        <tr key={index}>
                          <td>{v.recId}</td>
                          <td>{v.version}</td>
                          <td>{v.deleted && "deleted"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </div>
        </Card.Body>
      )}
    </Card>
  );
}

export default ChangeSetDisplay;
